import React from "react";
import { Container, Grid, Box } from "@mantine/core";
import Topbar from "../../../components/Topbar";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import TableLoader from "../../../components/TableLoader";
import { getNotifications } from "../../../services/notification";
import { TrackPageView } from "../../../config/mixpanelConfig";
import NotificationCard from "../../../components/NotificationCard";
import useStyles from "./style";

const Notification = () => {
  const { classes } = useStyles();
  const { notifications, total, getNotificationLoading } = useSelector(
    (state) => state.notification
  );
  const [page, setpage] = useState(1);
  const [perPage] = useState(2);

  const handlePageChange = (pageNumber) => {
    setpage(pageNumber);
  };

  const getData = async () => {
    await getNotifications({ page: 1, perPage : 10, client: "" });
  };
  useEffect(() => {
    getData();
  }, [page]);

  useEffect(() => {
    TrackPageView("Notification");
  }, []);

  return (
    <Container fluid className={classes.content} px={20}>
      <Topbar title={"Notification"} />
      <Box className={classes.mainContainer}>
        {getNotificationLoading ? (
          <TableLoader />
        ) : (
          <>
            <Grid>
              {notifications?.today?.map((item, index) => (
                <Grid.Col key={index} xs={12} md={6} lg={3} xl={3}>
                  {/* <----- Make a component for better maintainability -----> */}
                  <NotificationCard item={item} />
                </Grid.Col>
              ))}
            </Grid>

            <CustomPagination
              data={total}
              currentPage={page}
              itemsPerPage={perPage}
              handlePageChange={handlePageChange}
            />
          </>
        )}
      </Box>
    </Container>
  );
};

export default Notification;
